// Exclusao de conta no painel: chama a edge account-delete e repete enquanto o
// bot ainda desloga as sessoes (202 pending_logout). Logica pura + injetavel.

export const DELETION_MAX_ATTEMPTS = 6;
export const DELETION_RETRY_MS = 5_000;
export const MAX_DELETION_REASON = 500;
export const SUPPORT_EMAIL = "suporte@lucralink.com.br";

/** Categorias do motivo (mesmas da edge account-delete e do CHECK no banco). */
export const DELETION_REASON_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: "price", label: "Está caro para mim" },
  { value: "missing_feature", label: "Falta um recurso que preciso" },
  { value: "technical_issues", label: "Tive problemas técnicos" },
  { value: "switching_tool", label: "Vou usar outra ferramenta" },
  { value: "temporary", label: "Vou dar uma pausa" },
  { value: "other", label: "Outro motivo" },
];

export type DeletionCallResult =
  | { readonly kind: "deleted" }
  | { readonly kind: "pending" }
  | { readonly kind: "error"; readonly code: string };

export type DeletionFinal = { readonly ok: true } | { readonly ok: false; readonly message: string };

const ERROR_MESSAGES: Readonly<Record<string, string>> = {
  name_mismatch: "O nome digitado não confere com o nome da empresa.",
  reason_too_long: `O motivo pode ter no máximo ${MAX_DELETION_REASON} caracteres.`,
  stripe_cancel_failed:
    "Não conseguimos cancelar sua assinatura agora, então nada foi apagado. Tente de novo ou fale com o suporte.",
  purge_failed:
    "Sua assinatura já foi encerrada e nenhuma nova cobrança será feita, mas a limpeza dos dados não terminou. Tente excluir de novo em alguns minutos.",
  not_configured: "A exclusão de conta está indisponível no momento. Fale com o suporte para concluir.",
  pending_timeout:
    "Ainda estamos desconectando suas contas de WhatsApp e Telegram. Tente de novo em alguns minutos.",
};

export function deletionErrorMessage(code: string): string {
  return ERROR_MESSAGES[code] ?? "Não foi possível excluir a conta agora. Tente de novo em instantes.";
}

/** Habilita o botao final: nome igual ao da empresa (sem caixa/espacos) e motivo no limite. */
export function canConfirmDeletion(typed: string, companyName: string, reason: string): boolean {
  const a = typed.trim().toLocaleLowerCase("pt-BR");
  return a !== "" && a === companyName.trim().toLocaleLowerCase("pt-BR") && reason.length <= MAX_DELETION_REASON;
}

/** Repete a chamada enquanto vier "pending", ate o limite de tentativas. */
export async function runDeletionWithRetry(
  call: () => Promise<DeletionCallResult>,
  sleep: (ms: number) => Promise<void>,
  maxAttempts: number = DELETION_MAX_ATTEMPTS,
): Promise<DeletionFinal> {
  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    const result = await call();
    if (result.kind === "deleted") return { ok: true };
    if (result.kind === "error") return { ok: false, message: deletionErrorMessage(result.code) };
    if (attempt < maxAttempts) await sleep(DELETION_RETRY_MS);
  }
  return { ok: false, message: deletionErrorMessage("pending_timeout") };
}
